<form [formGroup]="formGroup">
  <div class="border-b border-gray-900/10 pb-2">
    <h2 class="primary-sub-title">Error Message {{ item?.code }}</h2>
    <p class="secondary-small-text mb-2">
      {{ item?.swPartNumber?.displayId }}
    </p>

    <div class="mt-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
      <div class="col-span-full">
        <app-text-area
          [fieldIsRequired]="true"
          [fieldConfigurationAddress]="'errormessage.headerOnTerminal'"
          [warning]="translatableFieldsTerminalWarning"
          [label]="'Header on terminal'"
          [isTranslatable]="isNotDefaultLanguage"
          formControlName="headerOnTerminal"
          [reset$]="resetFieldTracking$"
          [rows]="1"
          [readonly]="updateTranslationFieldDisabled"
          [borderColorClass]="'border-terminal-field focus:ring-terminal-field focus:border-terminal-field'"
        ></app-text-area>
      </div>

      <div class="col-span-full">
        <app-text-area
          [fieldIsRequired]="false"
          [fieldConfigurationAddress]="'errormessage.detailsOnTerminal'"
          [warning]="translatableFieldsTerminalWarning"
          [label]="'Details on Terminal'"
          [isTranslatable]="isNotDefaultLanguage"
          formControlName="detailsOnTerminal"
          [reset$]="resetFieldTracking$"
          [readonly]="updateTranslationFieldDisabled"
          [borderColorClass]="'border-terminal-field focus:ring-terminal-field focus:border-terminal-field'"
        ></app-text-area>
      </div>
      <div class="col-span-full">
        <app-label-with-help for="category" class="primary-label" fieldConfigurationAddress="errormessage.category"
          >Category</app-label-with-help
        >
        <app-selection formControlName="category" [options]="errorCategories"></app-selection>
      </div>
      <div class="inline-flex items-center justify-center col-span-full relative">
        <hr class="w-64 h-px my-8 bg-gray-200 border-0" />
        <span class="absolute px-3 font-normal text-gray-500 -translate-x-1/2 bg-white left-1/2">optional</span>
      </div>
      <div class="col-span-full border-gray-900/10">
        <app-text-area
          [label]="'Internal notes'"
          [fieldConfigurationAddress]="'errormessage.internalNotes'"
          [fieldIsRequired]="false"
          formControlName="internalNotes"
          [reset$]="resetFieldTracking$"
        ></app-text-area>
      </div>
      <div class="col-span-full flex justify-end">
        <button
          [disabled]="formGroup.invalid || sendButtonDisabled"
          [ngClass]="{
            'cursor-not-allowed': formGroup.invalid,
            'opacity-25': formGroup.invalid,
          }"
          (click)="requestPropagationOfChangesToEntitiesInOtherVersions()"
          type="button"
          class="crud-btn-sidebar"
          appAgentAction
          agent="edit-error-message-save"
          businessObject="errorMessage"
          [businessId]="$safeNavigationMigration(item?.id)"
          action="save"
        >
          <app-floppy-icon></app-floppy-icon>
        </button>
      </div>
    </div>
  </div>
</form>
<div class="pt-10 pb-6">
  <app-linked-dtcs [errorMessageId]="$safeNavigationMigration(item?.id)"></app-linked-dtcs>
</div>
<app-propagate-error-message-changes-to-entities-in-other-versions-modal
  #propagateChangesToEntitiesInOtherVersions
  (changesConfirmed)="confirmChanges($event)"
  (notPropagateChanges)="confirmChanges()"
></app-propagate-error-message-changes-to-entities-in-other-versions-modal>
